import { isEmpty, uniq, uniqBy } from "lodash";
import { TtrainingKeyParameter } from "../types/trainingKeyParameter.type";
import { TKeyParamLayout } from "../types/exam.type";

export type TgroupKeyParam = { key?: string, title?: string, detail?: string, id?: string }

export function groupKeyParamsByCategories(data: TKeyParamLayout[]): TgroupKeyParam[] {
    let categories: TgroupKeyParam[] = []



    if (!isEmpty(data)) {
        data.forEach(keyParam => {
            categories.push(getGroupedKeyParamFromLayout(keyParam))
        })
    }
    categories = uniqBy(categories, 'key')

    return categories

}

export function getAllLayoutKeysFromData(data: TtrainingKeyParameter) {

    if (isEmpty(data.items)) return []

    let first_element = data.items.at(0)

    return first_element?.computed_key_parameters.map(keyParam => keyParam.key_parameter_layout)
}

export function getGroupedKeyParamFromLayout(item?: TKeyParamLayout): TgroupKeyParam {
    return {
        key: item?.insight_parameter?.name,
        title: item?.insight_parameter?.name_translated,
        detail: item?.insight_parameter?.details_translated,
        id: item?.insight_parameter?.["@id"]
    }
}